// src/utils/gtm.js

// Initialize dataLayer if not exists
export const initializeGTM = () => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
  }
};

// Push events to GTM
export const pushToDataLayer = (event) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push(event);
  }
};

// Food Delivery Specific Events
export const trackPageView = (pageName) => {
  pushToDataLayer({
    event: 'page_view',
    page_name: pageName,
    page_title: document.title,
    page_location: window.location.href
  });
};

export const trackOrderStart = () => {
  pushToDataLayer({
    event: 'order_start',
    event_category: 'E-commerce',
    event_action: 'Order Started',
    event_label: 'Mealzy Foods App',
    value: 0
  });
};

export const trackMenuView = (category) => {
  pushToDataLayer({
    event: 'menu_view',
    event_category: 'Menu',
    event_action: 'Category Viewed',
    event_label: category,
    menu_category: category
  });
};

export const trackAppDownload = (source) => {
  pushToDataLayer({
    event: 'app_download',
    event_category: 'App Download',
    event_action: 'Download Button Clicked',
    event_label: source,
    download_source: source
  });
};

export const trackPhoneCall = () => {
  pushToDataLayer({
    event: 'phone_call',
    event_category: 'Contact',
    event_action: 'Phone Number Clicked',
    event_label: '+91-7841097358',
    phone_number: '+91-7841097358'
  });
};

export const trackSectionView = (sectionName) => {
  pushToDataLayer({
    event: 'section_view',
    event_category: 'User Engagement',
    event_action: 'Section Viewed',
    event_label: sectionName,
    section_name: sectionName
  });
};

export const trackButtonClick = (buttonName, buttonLocation) => {
  pushToDataLayer({
    event: 'button_click',
    event_category: 'User Interaction',
    event_action: 'Button Clicked',
    event_label: buttonName,
    button_name: buttonName,
    button_location: buttonLocation
  });
};
